import { ApplicationConfig, isDevMode, provideZoneChangeDetection } from '@angular/core'
import { initializeApp, provideFirebaseApp } from '@angular/fire/app'
import { getAuth, provideAuth } from '@angular/fire/auth'
import { provideAnimations } from '@angular/platform-browser/animations'
import { PreloadAllModules, provideRouter, withPreloading } from '@angular/router'
import { provideServiceWorker } from '@angular/service-worker'

import { provideMarkdown } from 'ngx-markdown'

import { provideIconsInitializer } from '@yoshu-lib/core/config/register-icons.factory'
import { provideTranslate } from '@yoshu-lib/core/config/translate.provider'
import { provideHttp } from '@yoshu-lib/core/http/http.provider'

import { environment } from '@demo/env/environment'

import { routes } from './app.routes'
import { provideMarkdownCustomRenderer } from './core/config/marked-options.provider'
import { provideCore } from './core/core.providers'

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),

    ...provideCore(),

    provideHttp(),
    provideAnimations(),
    provideRouter(routes, withPreloading(PreloadAllModules)),
    provideFirebaseApp(() => initializeApp(environment.firebase)),
    provideAuth(() => getAuth()),
    provideMarkdown(),
    provideMarkdownCustomRenderer(),
    provideTranslate(),
    provideIconsInitializer(),
    provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000'
    })
  ]
}
